import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${colors.white};
  border-radius: 12px;

  @media (max-width: 768px) {
    padding: 12px;
    gap: 12px;
  }
`

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 1.5fr 1.5fr;
  gap: 24px;
  padding: 12px 20px;
  background-color: ${colors.gray100};
  border-radius: 8px;
  font-weight: 600;

  @media (max-width: 1400px) {
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 16px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`

export const TableHeaderCell = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray700};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${colors.gray300};
  border-radius: 8px;
  overflow: hidden;
`

export const TableRow = styled.div<{ $isClickable?: boolean }>`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 1.5fr 1.5fr;
  gap: 24px;
  padding: 20px;
  align-items: start;
  font-size: 14px;
  font-weight: normal;
  ${({ $isClickable }) =>
    $isClickable &&
    `
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: ${colors.gray50};
    }
  `};

  @media (max-width: 1400px) {
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 16px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 12px;
  }
`

export const CompanyCell = styled.div`
  display: flex;
  flex-direction: row;
  gap: 11px;
  justify-content: start;
  align-items: center;
`

export const CompanyName = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${colors.gray900};

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const CompanyDetails = styled.div`
  display: flex;
  flex-direction: column;
`

export const CompanyInn = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray600};

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`

export const DataCell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  position: relative;
`

export const DataLabel = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: row;
`

export const DataValue = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${colors.gray900};

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const DataBreakdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const BreakdownItem = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray600};

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`

export const ArrowIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  @media (max-width: 1024px) {
    position: static;
    margin-top: 8px;
  }
`
